import { render, staticRenderFns } from "./RaceCalendarDetail.vue?vue&type=template&id=4a35dcc0&scoped=true&"
import script from "./RaceCalendarDetail.vue?vue&type=script&lang=js&"
export * from "./RaceCalendarDetail.vue?vue&type=script&lang=js&"
import style0 from "./RaceCalendarDetail.vue?vue&type=style&index=0&id=4a35dcc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a35dcc0",
  null
  
)

export default component.exports